// extracted by mini-css-extract-plugin
export default {"root":"PasswordCard_root__eum1H","header":"PasswordCard_header__MWU-Y","date":"PasswordCard_date__UBPXM","edit_icon":"PasswordCard_edit_icon__PgFnB"};